import React, { useState } from 'react';
import WorksheetTemplateManager from '../components/worksheets/WorksheetTemplateManager';
import CommonPageHeader from '../components/common/CommonPageHeader';
import { RectangleStackIcon, PlusIcon } from '@heroicons/react/24/outline';

const WorksheetTemplatesPage: React.FC = () => {
  const [shouldOpenForm, setShouldOpenForm] = useState(false);

  const handleNewClick = () => {
    setShouldOpenForm(true);
  };

  const handleFormOpened = () => {
    setShouldOpenForm(false);
  };

  return (
    <div className="space-y-4 w-full min-w-0">
      <CommonPageHeader
        title="Munkalap sablonok"
        subtitle="Munkalap sablonok kezelése és létrehozása"
        icon={RectangleStackIcon}
      >
        <button
          onClick={handleNewClick}
          className="bg-white/20 backdrop-blur-sm text-white px-3 py-2 rounded-md text-sm flex items-center justify-center hover:bg-white/30 transition-colors"
        >
          <PlusIcon className="h-4 w-4 mr-2" />
          <span>Új sablon</span>
        </button>
      </CommonPageHeader>

      <WorksheetTemplateManager
        triggerNewForm={shouldOpenForm}
        onFormOpened={handleFormOpened}
      />
    </div>
  );
};

export default WorksheetTemplatesPage;
